import type { ActionBarCrossSellCardModel } from '~/utils/shop/buildActionBarCrossSellCards';
import type {
  ActionBarCrossSellCardTrackingPayload,
  ActionBarCrossSellHiddenReason,
  ActionBarMainProductType
} from './types';

const VISIBLE_ROW_COUNT = 3;

export function createActionBarSessionId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return `ab_${crypto.randomUUID()}`;
  }

  return `ab_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function slugifyActionBarCategory(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64);
}

export function resolveActionBarMainProductType(
  attributeSetName: string | undefined | null
): ActionBarMainProductType {
  const normalized = (attributeSetName ?? '').toLowerCase();
  if (normalized.includes('light')) {
    return 'light';
  }
  return 'camera';
}

export function buildActionBarCrossSellCardPayloads(
  cards: ReadonlyArray<ActionBarCrossSellCardModel>,
  browsedGroupIds: Readonly<Record<string, true>>
): ActionBarCrossSellCardTrackingPayload[] {
  return cards.map((card, index) => {
    const position = index + 1;
    const hasLengthVariants = card.variants.length > 1;
    return {
      category: slugifyActionBarCategory(card.groupLabel || card.groupId),
      product_sku: card.productSku,
      selected_length_sku: hasLengthVariants ? card.selectedVariantSku : null,
      position,
      row: position <= VISIBLE_ROW_COUNT ? 1 : 2,
      browsed_not_selected: browsedGroupIds[card.groupId] === true
    };
  });
}

export function resolveActionBarHiddenReason(params: {
  hasRecommendedProducts: boolean;
  openGroupCount: number;
  cardsAfterDeliveryFilter: number;
}): ActionBarCrossSellHiddenReason {
  if (!params.hasRecommendedProducts) {
    return 'no_recommendations_for_product';
  }

  if (params.openGroupCount > 0 && params.cardsAfterDeliveryFilter === 0) {
    return 'no_delivery_time_match';
  }

  return 'all_categories_in_cart';
}
